import React from "react";
import { ThemeProvider } from "@mui/material/styles";
import { withDesignFont } from "services/constants/designTokens";
import { LeaveDetailsScreen } from "./LeaveDetailsScreen";
import "./ButtonGroup.css";
import "react-toastify/dist/ReactToastify.css";

// My Zone > "View Leave Balance" (/admin/myzone/myleaves). The redesigned
// Leave Details screen owns its own data fetching (leaves-years,
// leavetypefilter, leavesummary), so this route wrapper only supplies the
// design font. See LeaveDetailsScreen for the layout.
export const MyLeaves = () => {
  return (
    <ThemeProvider theme={withDesignFont}>
      <LeaveDetailsScreen />
    </ThemeProvider>
  );
};
